// Cliente único de Supabase para todo el frontend.
// Las credenciales son públicas (anon key) — la seguridad real vive en RLS.
import { createClient } from '@supabase/supabase-js';

const URL  = process.env.REACT_APP_SUPABASE_URL;
const ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!URL || !ANON) {
  // No tiramos el build (mockApi puede correr sin Supabase),
  // pero avisamos para que la primera persona que arme el proyecto sepa qué llenar.
  // eslint-disable-next-line no-console
  console.warn(
    '[mezo] Faltan REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_ANON_KEY en .env. ' +
    'Pon REACT_APP_USE_MOCK=true mientras no estén configuradas.'
  );
}

// ── Demo pública (/demo) ─────────────────────────────────────────────────────
// Flag en localStorage que activa el modo mock EN PRODUCCIÓN, aunque haya
// credenciales reales de Supabase. Solo se enciende entrando a /demo
// (DemoEntrada.jsx) y se apaga al salir del demo o crear cuenta.
// Se lee UNA sola vez al cargar el módulo: cambiarlo requiere full reload
// (window.location), que es exactamente lo que hace DemoEntrada — así el
// barrel de servicios (services/index.js) re-evalúa sin refactor alguno.
const _demoFlag = typeof window !== 'undefined' && (() => {
  try { return localStorage.getItem('mezo_demo') === '1'; } catch { return false; }
})();

// Para la UI (banner "Estás en el demo" en DashboardLayout).
export const DEMO_MODE = _demoFlag;

// Regla a prueba de balas: si hay credenciales de Supabase, SIEMPRE se usa
// el backend real — sin importar REACT_APP_USE_MOCK. El modo mock solo aplica
// cuando NO hay Supabase configurado (desarrollo sin backend)…
// …con UNA excepción deliberada: el demo público (/demo) fuerza mock aunque
// haya credenciales. Un usuario real jamás activa esto salvo entrando a /demo.
export const SUPABASE_CONFIGURED = !!(URL && ANON);
export const USE_MOCK = (!SUPABASE_CONFIGURED && process.env.REACT_APP_USE_MOCK === 'true') || _demoFlag;
// Mock SOLO de desarrollo (build con REACT_APP_USE_MOCK=true y sin Supabase).
// A diferencia de USE_MOCK, NO se enciende con el demo público (/demo): sirve
// para pantallas internas (CRM de TemeT) que no deben aparecer en la demo.
export const MOCK_DEV = !SUPABASE_CONFIGURED && process.env.REACT_APP_USE_MOCK === 'true';

// Exportadas para hacer peticiones REST directas con el token adjuntado a mano.
export const SUPABASE_URL      = URL ?? '';
export const SUPABASE_ANON_KEY = ANON ?? '';

// `||` y no `??`: una env var presente pero VACÍA ('' — típico en CI o al
// forzar modo mock) también cuenta como "sin configurar" — igual que en
// SUPABASE_CONFIGURED arriba. Con ?? el createClient reventaba con ''.
export const supabase = createClient(URL || 'https://placeholder.supabase.co', ANON || 'placeholder', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'mezo_supabase_auth',
  },
});

export const BUSINESS_KEY = 'mezo_business_id';

export function getBusinessId() {
  return typeof window !== 'undefined' ? localStorage.getItem(BUSINESS_KEY) : null;
}

export function setBusinessId(id) {
  if (typeof window === 'undefined') return;
  if (id) localStorage.setItem(BUSINESS_KEY, id);
  else    localStorage.removeItem(BUSINESS_KEY);
}
